module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAhCAYAAAC803lsAAAAAXNSR0IArs4c6QAAAVZJREFUWEftliFLBUEUhb8DBoM/wGBQMFjtBkHsBgWLIGhT8M9oUzQ88IH+BIvNaLe8Itg1GIQrV97Ksuzu7LydRcNMefDm3jtnzz33zIjpMrMt4AZYKv6b8XcCHEp6jMlXCcgLsBqT3BL7LGk9plYZiMUkBmInklZi6mUgVbYyI7GMfAJvAdEtAvOVmORi3ZN03wbEzHaBu6GBnEq6CAA5Ac7rgExNcqMh39keSXr1/UHFambX7rItH/Igafs/APnV0l8z0hlIr6np0JrOQHpNTUogfacmJNbOjMRcoOXYnwNSMpKB1DHgT7+2tVyzmbw1B5JGAYvfB24bLD6ZWI8lXQWAHAGXQwPx+v4McGOrW379+zOgupK3Jk/NrAzk1oSYy2LtrxEzOwN2gM0Q3xH77jtPwFqDzxSlirixzOwdWIg4ZIjQDwfiFu33xdwQJ3So+QWMvwGX1zjl4WlHhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/image/imgp2.png
// module id = xh0H
// module chunks = 0